import { compile } from 'path-to-regexp';
import { LoginType } from '@mm/state/controllers/SessionController';

export const routes = {
  signin: {
    path: '/signin/:type?',
    compile(type?: LoginType) {
      return compile(routes.signin.path)({ type });
    },
  },
  signup: {
    path: '/signup/:type?',
    compile(type?: LoginType) {
      return compile(routes.signup.path)({ type });
    },
  },
  resetPassword: {
    path: '/reset-password/:type?',
    compile(type?: LoginType) {
      return compile(routes.resetPassword.path)({ type });
    },
  },
};
